import { firebaseDB } from "../firebase/firebase";
import { collection, doc, setDoc, deleteDoc, getDoc } from "firebase/firestore";
import { Bank, BankId } from "../../domain/types/banks/Bank";

export class FirestoreBankRepository {
  private banksCollection = collection(firebaseDB, "banks");

  async create(bank: Bank): Promise<void> {
    const bankRef = doc(this.banksCollection, bank.institution_id);
    console.debug("Creating bank:", bank);
    await setDoc(bankRef, bank);
  }

  async delete(bankId: BankId): Promise<void> {
    const bankRef = doc(this.banksCollection, bankId);
    await deleteDoc(bankRef);
  }

  async getBankById(bankId: BankId): Promise<Bank | null> {
    const bankDoc = await getDoc(doc(this.banksCollection, bankId));
    return bankDoc.exists() ? (bankDoc.data() as Bank) : null;
  }
}
